import { Controller } from "stimulus";
import { showLdp } from "../../helpers/ldp_navigation_helpers"
import {getState, setState} from '../../search_results/state'
import { mapListConnection } from '../../search_results/map_list_connection'
import { SearchItemContainer } from '../../search/search_item_container'
import { translations } from '../../translations.js.erb'
import { FlexmlsMap } from '../../map/flexmls_map'
import { markerManager } from '../../map/marker_manager'
import mapConverters from '../../map/map_converters'
import Filter from "../../filter";
import GlobalOverlayManager from "../../global_overlay_manager"
import { searchFormFlex } from '../../listings/search_form_flex'
import { nativeAppInterface } from "../../native_app_interface";
import {
  createOverlayShapeAnnotation,
  removeOverlayShapeAnnotation,
  removeOverlayShapeAnnotations,
  createDrawnShapeAnnotation,
  removeDrawnShapeAnnotation,
  removeDrawnShapeAnnotations,
  clearAllAnnotations
} from '../../search/annotation_helper';
import { showRadiusSearchModal } from '../../helpers/radius_search_helpers';
import Cookies from 'js-cookie';
import { isAddressSearchType } from '../../map/map_search_type_helpers';

/** When set (e.g. "1"), skip the GPS confirmation modal and run location immediately */
const SUPPRESS_GPS_SEARCH_CONFIRM_COOKIE = 'suppressGpsSearchConfirm';

export default class extends Controller {

  static values = {
    googleMapsApiUrl: String
  }

  map = null
  mapListConnection = null
  currentOpenMenu = null

  /** Set while prefilter teardown batch-reloads the form so we skip MLS refit and defer one clusters refresh until reload completes */
  _preserveViewportAfterPrefilterReload = false

  /** Set when an address-search count-only reload freezes the map until the next tick */
  _addressSearchReloadFreeze = false

  connect(evt) {
    this.load_google()

    if (this.map === null) {
      var defaultOptions = {
        contactId: window.mapSupport.contactId,
        currencySymbol: window.mapSupport.currencySymbol,
        mlsDefaultBounds: window.mapSupport.mlsDefaultBounds,
        translations: translations.map,
        loadingMessage: {
// These are causing problems when the map is not visible at startup
// When the summary view is the staring view, the map puts up the spinner
// until the clusters are finished loading.  On smaller phones, the map
// is loaded but not visible.  But the clusters wont finish loading until
// the map has become a visible part of the page.  For now, take this
// out.  We already have a "Loading..." msg when the turbo-frame is loading.
// If we need an indicator to show that clusters are in the process of
// loading, we can put it in at the turbo-frame level instead of the main
// page level (where the UIL is in charge of displaying it.)
//          start: showPageLoadingMsg,
//          stop: hidePageLoadingMsg
        },
        drawingCompleteCallback: this.drawingCompleteCallback.bind(this)
      };
      var mapOptions = $.extend({}, defaultOptions, {});
      this.map = new FlexmlsMap(document.getElementById('map'), mapOptions);

      this.map.init();
      $(document).off('click', '#overlayKeyBtn, .overlaysPopover, .moreMapToolsBtn, .shapesPopover');

      // Add map event handlers
      this.addMapEventHandlers();

      // This is a fresh map.  If there are overlays/shapes in the filter, we should draw them now.
      this.addFilterOverlayShapesToMap(getState('filter'))
      $(document).on('mouseenter', '#contains-MapOverlayShape li.select2-selection__choice', this.highlightOverlayShape.bind(this));
      $(document).on('mouseleave', '#contains-MapOverlayShape li.select2-selection__choice', this.unhighlightOverlayShape.bind(this));
      $(document).on('mouseenter', '#contains-drawings li.select2-selection__choice', this.highlightDrawnShape.bind(this));
      $(document).on('mouseleave', '#contains-drawings li.select2-selection__choice', this.unhighlightDrawnShape.bind(this));

      // Setup escape key handler for menu closing
      $(document).on('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeCurrentMenu();
        }
      });
    }

    // Check for the openDrawingTools param.
    const turboFrame = this.element.closest('turbo-frame');
    if (turboFrame) {
      const frameSrc = turboFrame.getAttribute("src");
      if (frameSrc) {
        // Parse the URL using the URL API
        const url = new URL(frameSrc, window.location.origin); // Ensure absolute URL
         // Use URLSearchParams to check for the 'openDrawingTools' parameter
        const params = url.searchParams;
        if (params.get('openDrawingTools') === 'true') {
          document.getElementById('drawOnMapBtn').click()
        } else if (params.get('openRadiusSearch') === 'true') {
          showRadiusSearchModal();
        }
      }
    }

    this._boundMyLocationConfirmed = this.runMyLocationConfirmed.bind(this);
    window.addEventListener("map:myLocationConfirmed", this._boundMyLocationConfirmed);

    this._boundFilterFormReloaded = this._filterFormReloadedWhenFilterUnchanged.bind(this);
    window.addEventListener('filterForm:reloaded', this._boundFilterFormReloaded);

    this._boundFilterFormReloadStarting = this._filterFormReloadStarting.bind(this);
    window.addEventListener('filterForm:reloadStarting', this._boundFilterFormReloadStarting);
  }

  /**
   * The edit POST can take a while; abort stale cluster requests as soon as the form reload starts.
   */
  _filterFormReloadStarting() {
    if (this.map) {
      this.map.cancelPendingClusterRequests();
    }
  }

  /**
   * Count-only form reloads do not emit stateChange:filter; briefly freeze so map listeners
   * do not refetch during DOM refresh. When the filter changes, filterChangedCallback owns freeze/unfreeze.
   */
  _filterFormReloadedWhenFilterUnchanged(event) {
    if (!this.map) {
      return;
    }

    const expressions = event.detail?.expressions;
    if (!expressions) {
      return;
    }

    const existingFilter = getState('filter');
    if (!existingFilter) {
      return;
    }

    const newFilter = new Filter(expressions, window.mapSupport.locationFields);
    if (existingFilter.toString() !== newFilter.toString()) {
      return;
    }

    this._addressSearchReloadFreeze = true;
    this.map.freeze();
    window.setTimeout(() => {
      if (!this._addressSearchReloadFreeze) {
        return;
      }
      this._addressSearchReloadFreeze = false;
      if (this.map) {
        this.map.unfreeze();
      }
    }, 0);
  }

  disconnect() {
    this._addressSearchReloadFreeze = false;

    if (this._boundFilterFormReloaded) {
      window.removeEventListener('filterForm:reloaded', this._boundFilterFormReloaded);
      this._boundFilterFormReloaded = null;
    }

    if (this._boundFilterFormReloadStarting) {
      window.removeEventListener('filterForm:reloadStarting', this._boundFilterFormReloadStarting);
      this._boundFilterFormReloadStarting = null;
    }

    if (this._boundMyLocationConfirmed) {
      window.removeEventListener("map:myLocationConfirmed", this._boundMyLocationConfirmed);
      this._boundMyLocationConfirmed = null;
    }

    this.map.resetShapesMenu();
    this.map.onMapUnload();
    // No map? No map bounds!  Otherwise, the next time we load the map, the same
    // map bounds could be loaded and we wouldn't update the clusters.
    setState('mapBounds',null);

    GlobalOverlayManager.clearAllFilteredShapes();
    $(document).off('mouseenter', '#contains-drawings li.select2-selection__choice');
    $(document).off('mouseleave', '#contains-drawings li.select2-selection__choice');
    $(document).off('mouseenter', '#contains-MapOverlayShape li.select2-selection__choice');
    $(document).off('mouseleave', '#contains-MapOverlayShape li.select2-selection__choice');
  }

  closeCurrentMenu() {
    if (this.currentOpenMenu) {
      $('#mapContextMenu').remove();
      $('#drawnShapesListMenu').remove();
      this.currentOpenMenu = null;
      // Also close the drawn shape manager when closing menu
      this.map.resetShapesMenu();
    }
  }

  getCurrentMenuElement() {
    if (this.currentOpenMenu === 'context') {
      return $('#mapContextMenu');
    } else if (this.currentOpenMenu === 'drawnShapes') {
      return $('#drawnShapesListMenu');
    }
    return null;
  }

  updateMenuState(menuType) {
    this.currentOpenMenu = menuType;
  }

  calculateMenuPosition(x, y, menuWidth = 200, menuHeight = 100) {
    const windowWidth = $(window).width();
    const windowHeight = $(window).height();
    const padding = 16;

    // Use the same simple approach as the shape editing menu
    // Ensure menu stays within screen boundaries on both sides
    const finalX = Math.max(padding, Math.min(x, windowWidth - menuWidth - padding));

    // For vertical positioning, try below first, then above if it doesn't fit
    let finalY = y;
    if (y + menuHeight > windowHeight - padding) {
      finalY = y - menuHeight;
      // If it still doesn't fit above, align with top edge
      if (finalY < padding) {
        finalY = padding;
      }
    }

    return { x: finalX, y: finalY };
  }

  clearTempMarkers(evt) {
    this.closeCurrentMenu();
    this.map.deleteTemporaryMarkersAndStuff();
  }

  drawShapes(evt) {
    // Something outside the maps controller asked us to draw shapes
    this.closeCurrentMenu();
    $('.shapesPopover').trigger('click')
  }

  radiusSearch(evt) {
    // Something outside the maps controller asked us to do a radius search
    this.closeCurrentMenu();
    showRadiusSearchModal();
  }

  async filterChangedCallback(newExpressions, oldExpressions) {

    let newFilter = new Filter(newExpressions, mapSupport.locationFields);

    var added   = new Filter(Filter.expressionsAdded(oldExpressions, newExpressions), mapSupport.locationFields);
    var removed = new Filter(Filter.expressionsRemoved(oldExpressions, newExpressions), mapSupport.locationFields);

    var deleteAnnotations = true;
    newExpressions.forEach( function(expression) {
      if (expression.type === 'shape' || expression.field === 'MapOverlayShape') {
        deleteAnnotations = false;
      }
    });

    if (deleteAnnotations) {
      clearAllAnnotations();
    }

    if(getState('mapBounds') === null){
      setState('filter', newFilter);

    } else if(typeof this.map === 'undefined'){
      setState('filter', newFilter);

      if(added.locations().length > 0 || removed.locations().length > 0) {
        setState('mapBounds', null);
      }

    } else {
      let shapesAddedOrRemoved = false
      if (added.shapes().length > 0 || removed.shapes().length > 0) {
        this.map.refreshMapShapes()
        shapesAddedOrRemoved = true
      }

      if (added.locations().length > 0 || removed.locations().length > 0) {
        // Remove unfiltered shapes first.  When shape operators/conjunctions change,
        // we might end up deleting a valid shape.  But if we do the remove first,
        // we will properly add the shape back to the map.
        this.removeUnfilteredShapesFromMap(removed)
        // Then add the filtered shapes
        await this.addFilterOverlayShapesToMap(added)
        shapesAddedOrRemoved = true
      }

      if (this._preserveViewportAfterPrefilterReload) {
        // Map was frozen in disablePrefilteredFields; avoid MLS refit and duplicate updateMap here.
        // jqXHR.always unfreezes and runs a single updateMap after reloadData finishes.
        this._preserveViewportAfterPrefilterReload = false;
        return;
      }

      if (!this.map._frozen) {
        this.map.freeze();
      }

      this.map.updateMapAndFitToCurrentListingResults({
        bounds: null,
        suppressBoundsRefetch: true
      })
        .done(() => {
          if (!isAddressSearchType()) {
            setState('listingCountTotal', this.map.mappedListingCount());
          }
        })
        .fail((e) => {
          if (e?.message) {
            console.log(e.message);
          }
        })
        .always(() => {
          this.map.unfreeze();
        });
    }
  }

  filterChanged(data) {
    // Someone changed the filter.  Close the menu if it is open.
    this.closeCurrentMenu()
    if (this.map) {
      this.map.cancelPendingClusterRequests();
    }
    // Freeze before filterChangedCallback so flexmls_map does not issue a duplicate
    // clusters request (stateChange:filter listeners run synchronously).
    if (this.map && getState('mapBounds') !== null && !this.map._frozen) {
      this.map.freeze();
    }
    this.filterChangedCallback(data.detail.newValue._data, data.detail.oldValue._data);
  }

  drawingCompleteCallback(filter, newBounds, annotation, options = {}) {
    this.map.freeze();

    if (annotation) {
      // Create drawn shape annotation using helper
      createDrawnShapeAnnotation(
        annotation.Match.Substring,
        annotation.Attributes.Label,
        annotation.Attributes.Color,
        { radiusSearch: options.radiusSearch }
      );
    }

    setState('filter', filter);

    // Always redraw listing markers (e.g. after shape edit). moveMapToBoundary's
    // promise may never resolve if the map is already at newBounds, so we don't
    // rely on it for updateMap() or unfreeze.
    this.map.updateMap().done(() => {
      setState('listingCountTotal', this.map.mappedListingCount());
      this.map.unfreeze();
    });

    this.map.moveMapToBoundary(newBounds).then((bounds) => {
      setState('mapBounds', bounds);
      this.map.unfreeze();
      this.map.updateMap().done(() => {
        setState('listingCountTotal', this.map.mappedListingCount());
      });
    });
  }

  mapZoomIn(evt){
    this.closeCurrentMenu();
    this.map.googleMap.setZoom(this.map.googleMap.getZoom() + 1);
  }

  mapZoomOut(evt){
    this.closeCurrentMenu();
    this.map.googleMap.setZoom(this.map.googleMap.getZoom() - 1);
  }

  showListingCard(evt) {
    if (evt.detail === null) {
      markerManager.deletePopupMarkers();
    } else {
      markerManager.addPreviewMarker(evt.detail);
    }
  }

  showLdpFromMap(evt) {
    this.map.resetShapesMenu()
    var target = $(evt.target)

    if (
        (target.hasClass('marker-preview-wrapper-above') || target.hasClass('marker-preview-wrapper-below') ) ||
        (target.closest('.rsArrowLeft').length) ||
        (target.closest('.rsArrowRight').length)||
        (target.closest('.saveListingLink').length) ) {
      // let addToCollection deal with it
    } else {
      evt.preventDefault()
      // Prevent multiple fast clicks from attempting more than one load of the LDP
      if ($('#priorityOverlay').hasClass('loading')) return
      $('#priorityOverlay').addClass('loading')

      // The url for the listing detail page is stored in a data attribute on
      // the preview. If the preview is clicked, we need to look up the dom to
      // find it, but if the outermost wrapper was clicked, we need to look
      // inside the clicked element.
      var urlHolder = $(evt.target).closest('[data-listing-show-url]')

      if(urlHolder.length < 1) {
        urlHolder = $(evt.target).find('[data-listing-show-url]')
      }

      var requestUrl = new URL(urlHolder.attr('data-listing-show-url'))

      // TODO: Fix this inside the preview card
      if (requestUrl.searchParams.has('listing_id')) requestUrl.searchParams.delete('listing_id')
      if (requestUrl.searchParams.has('view')) requestUrl.searchParams.delete('view')

      var listingUrl = requestUrl.href
      let browserUrl = listingUrl

      // TODO: Add the listing id as an attribute somewhere in the preview card
      let pattern = /\/listings\/(\d{26})/
      let match_result = listingUrl.match(pattern)
      let listingId = match_result[1]

      var mapItem = markerManager.getMarkerInfoById(listingId)
      listingUrl = listingUrl.replace("/listings/","/listing_detail/");
      if (mapItem !== null) {
        mapItem.listingUrl = listingUrl
        mapItem.pushState = true
        mapItem.browserUrl = browserUrl
        showLdp(mapItem)
      } else {
        console.log("No marker information found. This should not happen.")
      }
    }
  }

  requestPreviousListing(evt) {
    var currentListingId = evt.detail
    var previousMarkerMapItem = markerManager.getPreviousMarkerInfo(currentListingId)

    if (previousMarkerMapItem === null) {
      // We should not get here because the previous button should have been disabled if
      // there were no more.  But just in case.
      console.log("No previous map markers found");
    }

    // Someone hit the prev button on an LDP.  Replace the current LDP with the new LDP
    var listingUrl = window.location.href;
    listingUrl = listingUrl.replace(currentListingId, previousMarkerMapItem.listingId);

    // Update the URL in the browser
    history.replaceState('','',listingUrl)
    // Adjust the URL to get the details frame
    listingUrl = listingUrl.replace("/listings/","/listing_detail/");

    previousMarkerMapItem.listingUrl = listingUrl
    previousMarkerMapItem.pushState = false;
    showLdp(previousMarkerMapItem);
  }

  requestNextListing(evt) {
    var currentListingId = evt.detail
    var nextMarkerMapItem = markerManager.getNextMarkerInfo(currentListingId)

    if (nextMarkerMapItem === null) {
      // We should not get here because the next button should have been disabled if
      // there were no more.  But just in case.
      console.log("No more map markers found");
    }

    // Someone hit the next button on an LDP.  Replace the current LDP with the new LDP
    var listingUrl = window.location.href;
    listingUrl = listingUrl.replace(currentListingId, nextMarkerMapItem.listingId);

    // Update the URL in the browser
    history.replaceState('','',listingUrl)

    // Adjust the URL to get the details frame
    listingUrl = listingUrl.replace("/listings/","/listing_detail/");

    nextMarkerMapItem.listingUrl = listingUrl
    nextMarkerMapItem.pushState = false;
    showLdp(nextMarkerMapItem);
  }

  refreshMapFromList(evt) {
    // The data action for this should only be defined if we are a newsfeed or notifications
    // It will update the map with the newly loaded items in the table/summary results.
    this.map.updateMap();
  }

  requestListingIds(event) {
    let listingIds = markerManager.getListingIds();
    const response = new CustomEvent(event.detail.returnEvent, {detail: { listingIds: listingIds }})
    window.dispatchEvent(response)
  }

  async addFilterOverlayShapesToMap(filter) {
    // This needs to be async so that we dont leave here until
    // all of the items have been added to the map.  Calls that
    // happen after this use the map shapes to define the map bounds.

    const promises = [];

    // Process MapOverlayShape entries
    const shapePromises = filter.locations()
        .filter(obj => obj.field === 'MapOverlayShape')
        .map(expression => (async () => {
            const shape = await GlobalOverlayManager.getMyMapOverlayShape(
                expression.condition.replaceAll("'", "")
            );
            GlobalOverlayManager.addFilterOverlayShapeToMap(shape.Id, shape);

            // Create annotation for this shape
            // This is important when shapes are both added and removed due to conjunction changes
            createOverlayShapeAnnotation(
              shape.Id,
              shape.OverlayId,
              shape.OverlayName,
              shape.Name
            );
        })());
    promises.push(...shapePromises);

    // Wait for all operations to complete
    await Promise.all(promises);

    // Toggle visibility to visible for all shapes
    this.toggleAllShapesVisibility(true);
  }

  toggleAllShapesVisibility(visible) {
    this.map.drawingManager.toggleVisibility(visible);
    GlobalOverlayManager.toggleFilteredOverlayShapesVisibility(visible);
    GlobalOverlayManager.toggleUnfilteredOverlayShapesVisibility(visible);
  }

  removeAllShapes() {
    GlobalOverlayManager.clearAllFilteredShapes();
    this.map.deleteAllDrawings();
    clearAllAnnotations();
  }

  removeUnfilteredShapesFromMap(filter) {
    // Remove overlay shapes from map and their annotations
    const shapesToRemove = filter.locations()
      .filter(obj => obj['field'] === 'MapOverlayShape')
      .map(expression => expression['condition']);

    shapesToRemove.forEach(condition => {
      GlobalOverlayManager.removeFilterOverlayShapeFromMap(condition.replaceAll("'",""));
    });

    // Remove annotations using helper
    if (shapesToRemove.length > 0) {
      removeOverlayShapeAnnotations(shapesToRemove);
    }
  }

  highlightOverlayShape(event) {
    let overlayShapes = $(event.currentTarget).find('[data-shape]')
    if (overlayShapes.length > 0) {
      GlobalOverlayManager.fillOverlayShape($(overlayShapes[0]).attr('data-shape').replaceAll("'",""), 0.9)
    }
  }

  unhighlightOverlayShape(event) {
    let overlayShapes = $(event.currentTarget).find('[data-shape]')
    if (overlayShapes.length > 0) {
      GlobalOverlayManager.fillOverlayShape($(overlayShapes[0]).attr('data-shape').replaceAll("'",""), 0.15)
    }
  }

  // Handle hover events from grouped select2 controller
  handleGroupedOverlaysHover(event) {
    const { parentId, childId, hoverType } = event.detail;

    if (childId !== null) {
      // Handle individual child item hover
      if (hoverType === 'start') {
        // Highlight the overlay shape
        const cleanId = childId.replaceAll("'", "");
        GlobalOverlayManager.fillOverlayShape(cleanId, 0.9);
      } else if (hoverType === 'finish') {
        // Unhighlight the overlay shape
        const cleanId = childId.replaceAll("'", "");
        GlobalOverlayManager.fillOverlayShape(cleanId, 0.25);
      }
    } else {
      // Handle group header hover - highlight all shapes in the group
      if (hoverType === 'start') {
        this.highlightAllShapesInGroup(parentId);
      } else if (hoverType === 'finish') {
        this.unhighlightAllShapesInGroup(parentId);
      }
    }
  }

  // Highlight all overlay shapes in a specific group
  highlightAllShapesInGroup(parentId) {
    // Find the group element in the DOM
    const groupElement = document.querySelector(`[data-group-parent="${parentId}"]`);
    if (!groupElement) return;

    // Get all child items in this group
    const childItems = groupElement.querySelectorAll('.child-item');

    // Highlight each shape using the existing GlobalOverlayManager method
    childItems.forEach(childItem => {
      const childId = childItem.getAttribute('data-child');
      if (childId) {
        const cleanId = childId.replaceAll("'", "");
        GlobalOverlayManager.fillOverlayShape(cleanId, 0.9);
      }
    });
  }

  // Unhighlight all overlay shapes in a specific group
  unhighlightAllShapesInGroup(parentId) {
    // Find the group element in the DOM
    const groupElement = document.querySelector(`[data-group-parent="${parentId}"]`);
    if (!groupElement) return;

    // Get all child items in this group
    const childItems = groupElement.querySelectorAll('.child-item');

    // Unhighlight each shape using the existing GlobalOverlayManager method
    childItems.forEach(childItem => {
      const childId = childItem.getAttribute('data-child');
      if (childId) {
        const cleanId = childId.replaceAll("'", "");
        GlobalOverlayManager.fillOverlayShape(cleanId, 0.25);
      }
    });
  }

  highlightDrawnShape(event) {
    let shapes = $(event.currentTarget).find('[data-shape]')
    if (shapes.length > 0) {
      this.map.highlightDrawnShape($(shapes[0]).attr('data-shape'))
    }
  }

  unhighlightDrawnShape(event) {
    let shapes = $(event.currentTarget).find('[data-shape]')
    if (shapes.length > 0) {
      this.map.unhighlightDrawnShape($(shapes[0]).attr('data-shape'))
    }
  }

  displayOverlayManager(event) {
    event.preventDefault();
    this.map.displayOverlayManager(event.detail);
  }

  newOverlayCreated(event) {
    // We have created a new overlay.
    let overlay = event.detail.overlay

    if (nativeAppInterface.isNative()) {
      nativeAppInterface.shapeConvertedToOverlay(overlay);
    }

    // Track drawn shapes to remove
    let drawnShapesToRemove = [];

    // Copy the current values from the location search box
    let searchLocationValues = $('#locationSearch').val() || [];

    const groupedSelectElement = document.getElementById('groupedOverlaysSelect');

    // Add each shape to the annotations
    for (const shape of overlay.Shapes){
      // Add the value to the locationSearch select2
      searchLocationValues.push('MapOverlayShape_' + shape.Id)

      // This is mimicicing what happens when you select an item in the location box - While the box is open and you
      // check an item, it adds the item to its underlying select and to the overlays select.
      let locationOption = `<option value="MapOverlayShape_${shape.Id}">${overlay.Name} - ${shape.Name} (Map Overlay Shape)</option>`
      $('#locationSearch').append($(locationOption))

      // Create annotation using shared utility (works for both old and new paths)
      createOverlayShapeAnnotation(
        shape.Id,
        overlay.Id,
        overlay.Name,
        shape.Name
      );

      // Add to new overlays select (grouped-select2) via event
      // If a new group is being created and an intersection already exists, use the intersection operator mode.
      let newGroupOperator = ($('.has-shapes-operator[data-active="and"]').length > 0) ? 'and' : 'or';

      const shapeData = {
        id: `'${shape.Id}'`,
        text: shape.Name,
        color: "#" + shape.Color,
        overlayId: overlay.Id,
        overlayName: overlay.Name,
        notFromLocations: true,
        newGroupOperator: newGroupOperator
      };

      groupedSelectElement.dispatchEvent(new CustomEvent('addOverlayShape', {
        detail: shapeData,
        bubbles: true
      }));
      SearchItemContainer.updateGroupedSelectSummary(document.getElementById('visualGroupedOverlaysSelect'));

      let drawnShapeMatch = this.getMatchingDrawnPolygon(shape)
      if (drawnShapeMatch.length > 0) {
        let shapeDefinition = drawnShapeMatch.val()
        drawnShapeMatch.remove()
        drawnShapesToRemove.push(shapeDefinition);
      }
    } // Done processing the shapes in the overlay.

    // Remove drawn shape annotations if any were replaced by overlay shapes
    if (drawnShapesToRemove.length > 0) {
      removeDrawnShapeAnnotations(drawnShapesToRemove);
    }

    // Ensure the container is checked and expanded (same as when adding from map)
    let $container = $(groupedSelectElement.closest('.c-card'));
    $container.removeClass('no-overlays');
    $container.find('.c-collapsible__content.filter_item_container').find('*').removeClass('dont_serialize');
    SearchItemContainer.expandContainer($container);
    SearchItemContainer.checkContainer($container, true);

    this.triggerFilterPanelUpdates(searchLocationValues, true)

    toast.success('Overlay created successfully.');
  }

  overlayUpdated(event) {
    // We have updated an existing overlay.
    let overlay = event.detail.overlay

    if (nativeAppInterface.isNative()) {
      nativeAppInterface.shapeConvertedToOverlay(overlay);
    }

    // Copy the current values from the location search box
    let searchLocationValues = $('#locationSearch').val() || [];

    const groupedSelectElement = document.getElementById('groupedOverlaysSelect');

    for (const shape of overlay.Shapes){
      // Only add the shapes that were added to the overlay.  We can tell which
      // ones those are by matching the shape definitions.
      let drawnShapeMatch = this.getMatchingDrawnPolygon(shape)
      if (drawnShapeMatch.length > 0) {
        let shapeDefinition = drawnShapeMatch.val()
        // Remove the drawn shape annotation using helper
        removeDrawnShapeAnnotation(shapeDefinition);
        // Remove the shape from the select
        drawnShapeMatch.remove();

        // Add the value to the locationSearch select2
        searchLocationValues.push('MapOverlayShape_' + shape.Id)

        // This is mimicicing what happens when you select an item in the location box - While the box is open and you
        // check an item, it adds the item to its underlying select and to the overlays select.
        let locationOption = `<option value="MapOverlayShape_${shape.Id}">${overlay.Name} - ${shape.Name} (Map Overlay Shape)</option>`
        $('#locationSearch').append($(locationOption))

        // Add to new overlays select (grouped-select2) via event
        // If a new group is being created and an intersection already exists, use the intersection operator mode.
        let newGroupOperator = ($('.has-shapes-operator[data-active="and"]').length > 0) ? 'and' : 'or';

        // The event handler will manage annotations via the event flow
        const shapeData = {
          id: `'${shape.Id}'`,
          text: shape.Name,
          color: "#" + shape.Color,
          overlayId: overlay.Id,
          overlayName: overlay.Name,
          notFromLocations: true,
          newGroupOperator: newGroupOperator
        };

        groupedSelectElement.dispatchEvent(new CustomEvent('addOverlayShape', {
          detail: shapeData,
          bubbles: true
        }));
        SearchItemContainer.updateGroupedSelectSummary(document.getElementById('visualGroupedOverlaysSelect'));
      }
    }

    // Ensure the container is checked and expanded (same as when adding from map)
    let $container = $(groupedSelectElement.closest('.c-card'));
    $container.removeClass('no-overlays');
    $container.find('.c-collapsible__content.filter_item_container').find('*').removeClass('dont_serialize');
    SearchItemContainer.expandContainer($container);
    SearchItemContainer.checkContainer($container, true);

    this.triggerFilterPanelUpdates(searchLocationValues, true)

    toast.success('Overlay updated successfully.');
  }

  triggerFilterPanelUpdates(searchLocationValues, workInProgress = true) {
    // Tell the locationSearch there are new values
    $('#locationSearch').val(searchLocationValues).trigger('change')
    // Process the changes as if you added them from the select2 and
    // are now done.
    $('#locationSearch').trigger('select2:close')
  }

  getMatchingDrawnPolygon(shape) {
    let drawnShapeMatch = $('#drawingsSelect option[value="' + shape.Geometry + '"]')
    if (drawnShapeMatch.length > 0) {
      return drawnShapeMatch
    }
    let possibleMatches = $('#drawingsSelect option[value^="polygon"]').filter(function() {
      // If it is a polygon with the same name, mark it as a possible match.
      return $(this).text() === shape.Name
    })
    if (possibleMatches.length === 0) {
      // We didnt find the shape in the drawingsSelect.
      console.log("No matching drawn shape found for new overlay shape: " + shape.Name)
      return []
    }
    let matchingShapes = $()

    possibleMatches.each(function() {
      let drawnShapeGeometry = $(this).val()
      let drawnPoints = drawnShapeGeometry.match(/[0-9.-]+\s[0-9.-]+/g)
      let shapePoints = shape.Geometry.match(/[0-9.-]+\s[0-9.-]+/g)
      if (drawnPoints.length !== shapePoints.length) {
        return // Skip if different number of points. Obviously, this is not a match.
      }

      // Check decimal places in coordinate strings
      let drawnDecimals = drawnPoints[0].split(' ').map(n => n.split('.')[1]?.length || 0)
      let shapeDecimals = shapePoints[0].split(' ').map(n => n.split('.')[1]?.length || 0)
      if (drawnDecimals[0] === shapeDecimals[0] && drawnDecimals[1] === shapeDecimals[1]) {
        // Same decimal precision was used, so exact string match already failed
        return;
      }

      // Different precision used, check if points match within tolerance
      let matches = drawnPoints.every((point, i) => {
        let [drawnLat, drawnLng] = point.split(' ').map(Number);
        let [shapeLat, shapeLng] = shapePoints[i].split(' ').map(Number);
        return Math.abs(drawnLat - shapeLat) < 0.000001 &&
                Math.abs(drawnLng - shapeLng) < 0.000001
      })

      if (matches) {
        matchingShapes = matchingShapes.add($(this))
      }
    })
    return matchingShapes
  }

  load_google() {
    // We only want to load the google script once.  With turboframes,
    // we could end up loading this multiple times without this check.
    // The script is typically loaded in the view via content_for :third_party_scripts,
    // but this serves as a fallback if it hasn't been loaded yet.
    if (!window.google) {
      const script = document.createElement('script');

      // Use the Google Maps API URL from the data attribute (set by helper method)
      script.src = this.googleMapsApiUrlValue;
      script.async = false;
      script.defer = true;

      script.onload = () => {
      // You can initialize your Google Maps functionality here
      };

      document.body.appendChild(script);
    }
  }

  addMapEventHandlers() {
    // Add a click handler to detect what was clicked on the map
    this.map.googleMap.addListener('click', (event) => {
      this.handleMapClick(event);
    });

    // Add a mousemove handler to detect what is under the mouse cursor
    this.map.googleMap.addListener('mousemove', (event) => {
      this.handleMapMouseMove(event);
    });
  }

  handleMapMouseMove(event) {
    // Detect what features are under the mouse cursor and highlight accordingly
    // But don't highlight/unhighlight when drawing is in progress
    if (this.map.drawingManager && this.map.drawingManager.drawingInProgress()) {
      return;
    }

    const mouseLatLng = event.latLng;

    // Use the same feature detection logic as handleMapClick
    const featuresUnderMouse = this.detectClickedFeatures(event);

    // First, unhighlight all overlay shapes
    const allOverlays = GlobalOverlayManager.data.overlaysOnTheMap;
    const filteredOverlayShapes = GlobalOverlayManager.data.filteredOverlayShapesOnTheMap;

    // Unhighlight all overlay shapes
    Object.keys(allOverlays).forEach(key => {
      allOverlays[key].forEach(googleShape => {
        try {
          googleShape.setOptions({ fillOpacity: 0.15 }); // Default opacity
        } catch (error) {
          console.log('Error setting opacity for overlay shape:', error);
        }
      });
    });

    Object.keys(filteredOverlayShapes).forEach(key => {
      filteredOverlayShapes[key].forEach(googleShape => {
        try {
          googleShape.setOptions({ fillOpacity: 0.25 }); // Default opacity
        } catch (error) {
          console.log('Error setting opacity for filtered overlay shape:', error);
        }
      });
    });

    // Unhighlight all drawn shapes
    if (this.map.drawingManager && this.map.drawingManager.drawings) {
      this.map.drawingManager.drawings.forEach(drawing => {
        try {
          drawing.setOptions({ fillOpacity: 0.5 }); // Default opacity
        } catch (error) {
          console.log('Error setting opacity for drawn shape:', error);
        }
      });
    }

    // Highlight features under mouse
    featuresUnderMouse.forEach(feature => {
      try {
        feature.shape.setOptions({ fillOpacity: 0.7 });
      } catch (error) {
        console.log('Error highlighting feature:', error);
      }
    });
  }

  handleMapClick(event) {
    // Don't show context menu if drawing is in progress
    if (this.map.drawingManager && this.map.drawingManager.drawingInProgress()) {
      return;
    }

    // Close existing menus
    mapConverters.closeGoogleInfoWindows()
    this.closeCurrentMenu();
    this.map.resetShapesMenu();

    // Save the latlng
    let clickLatLng = event.latLng;

    // Use Google to find features at the click point
    let clickPoint = new google.maps.LatLng(clickLatLng.lat(), clickLatLng.lng());

    // What shapes did we click on
    let clickedFeatures = this.detectClickedFeatures(event);

    // Close any existing menu before showing a new one
    this.closeCurrentMenu();

    // Check for markers first (they have highest priority) - only on touch devices
    if (Modernizr.touch) {
      const markerFeatures = [];
      this._detectMarkers(event, markerFeatures);

      if (markerFeatures.length > 0) {
        // If there's a marker at the click point, let the marker handle it
        // Stop the event to prevent Google Maps from processing it (e.g., POI info windows)
        event.stop();
        this.closeCurrentMenu();
        return;
      }
    }

    // If we clicked on the map (not a marker) clear parcel outlines and any preview popups.
    this.map.deleteTemporaryMarkersAndStuff();

    // Only filter shapes if we need to process them (no markers found)
    const drawnShapes = clickedFeatures.filter(feature => feature.type.includes('Drawn Shape'));
    const overlayShapes = clickedFeatures.filter(feature => feature.type.includes('Overlay Shape'));

    if (clickedFeatures.length === 1 && drawnShapes.length === 1) {
      // Stop event propagation to prevent Google's place info windows
      event.stop();

      // Trigger the shape's click event directly to let the drawing manager handle it
      const shape = drawnShapes[0].shape;
      const forwardedEvent = {
        domEvent: {
          pageX: event.domEvent.pageX,
          pageY: event.domEvent.pageY,
          clientX: event.domEvent.clientX,
          clientY: event.domEvent.clientY,
          target: event.domEvent.target,
          currentTarget: event.domEvent.currentTarget,
          type: 'click'
        },
        latLng: event.latLng,
        stop: event.stop
      };
      google.maps.event.trigger(shape, 'click', forwardedEvent);
    } else if (clickedFeatures.length > 0) {
      // Stop event propagation to prevent Google's place info windows
      event.stop();

      this.showContextMenu(event, clickedFeatures);
    } else {
      // No shapes or markers - let Google handle the place click
      // Google will automatically close any existing info windows and open new ones
      this.closeCurrentMenu();
    }
  }

  showContextMenu(event, features) {
    // Remove any existing context menu
    $('#mapContextMenu').remove();
    $('#drawnShapesListMenu').remove();

    // Create the context menu
    const menu = $('<div id="mapContextMenu" class="map-context-menu"></div>');

    // Add menu items for each feature
    features.forEach(feature => {
      const menuItem = this.createContextMenuItem(feature, event);
      menu.append(menuItem);
    });

    // Add the menu to the page
    $('body').append(menu);

    // Calculate optimal position using estimated dimensions
    const clickX = event.domEvent.pageX;
    const clickY = event.domEvent.pageY;
    const estimatedMenuWidth = 250; // Fixed width for consistency
    const estimatedMenuHeight = 50 + (features.length * 40); // Estimate height based on number of items
    const position = this.calculateMenuPosition(clickX, clickY, estimatedMenuWidth, estimatedMenuHeight);

    menu.css({
      left: position.x + 'px',
      top: position.y + 'px'
    });

    // Update menu state
    this.updateMenuState('context');
  }

  showDrawnShapeManagementMenu(event, drawnShapes) {
    // Remove any existing context menu
    $('#mapContextMenu').remove();
    $('#drawnShapesListMenu').remove();

    // Create a list menu showing all the shapes that were clicked
    const menu = $('<div id="drawnShapesListMenu" class="map-context-menu"></div>');

    // Add menu items for each drawn shape
    drawnShapes.forEach(shapeData => {
      const menuItem = this.createDrawnShapeListItem(shapeData, event);
      menu.append(menuItem);
    });

    // Add the menu to the page
    $('body').append(menu);

    // Calculate optimal position using estimated dimensions
    const clickX = event.domEvent.pageX;
    const clickY = event.domEvent.pageY;
    const estimatedMenuWidth = 250; // Fixed width for consistency
    const estimatedMenuHeight = 50 + (drawnShapes.length * 40); // Estimate height based on number of items
    const position = this.calculateMenuPosition(clickX, clickY, estimatedMenuWidth, estimatedMenuHeight);

    // Only set the dynamic positioning properties
    menu.css({
      left: position.x + 'px',
      top: position.y + 'px'
    });

    // Update menu state
    this.updateMenuState('drawnShapes');
  }

  createDrawnShapeListItem(shapeData, originalMapEvent) {
    const shape = shapeData.shape;
    const item = $('<div class="context-menu-item"></div>');

    // Get the shape color
    const color = shape.get('fillColor') || shape.get('strokeColor') || '#000000';
    const shapeName = shape.get('shapeName') || 'Unknown Shape';

    // Create color circle
    const colorCircle = $('<div class="color-circle"></div>').css({
      backgroundColor: color
    });

    // Create shape name
    const nameSpan = $('<span class="shape-name"></span>').text(shapeName);

    // Create action link
    const actionText = 'Edit shape';
    const actionLink = $('<a href="#" class="action-link edit-shape"></a>').text(actionText);

    // Create a container for the circle and name to keep them together
    const leftContainer = $('<div class="left-container"></div>');

    // Build the structure correctly from the start
    leftContainer.append(colorCircle, nameSpan);
    item.append(leftContainer, actionLink);

    // Add click handler for the entire menu item
    item.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.handleDrawnShapeListItemAction(shape, originalMapEvent);
      this.closeCurrentMenu();
    });

    return item;
  }

  handleDrawnShapeListItemAction(shape, originalMapEvent) {

    // Create a forwarded click event using the original map event coordinates
    const forwardedEvent = {
      domEvent: {
        pageX: originalMapEvent.domEvent.pageX,
        pageY: originalMapEvent.domEvent.pageY
      },
      latLng: originalMapEvent.latLng,
      stop: originalMapEvent.stop,
      stopImmediatePropagation: originalMapEvent.stopImmediatePropagation
    };

    // Trigger the click event on the shape to show the drawn shape management menu
    google.maps.event.trigger(shape, 'click', forwardedEvent);

  }

  createContextMenuItem(feature, originalMapEvent) {
    const item = $('<div class="context-menu-item"></div>');

    // Get the shape color
    const color = feature.shape.get('fillColor') || feature.shape.get('strokeColor') || '#000000';
    const shapeName = feature.shape.get('shapeName') || 'Unknown Shape';

    // Create color circle
    const colorCircle = $('<div class="color-circle"></div>').css({
      backgroundColor: color
    });

    // Create shape name
    const nameSpan = $('<span class="shape-name"></span>').text(shapeName);

    // Create action link based on feature type
    let actionText, actionClass;
    if (feature.type === 'Filtered Overlay Shape') {
      actionText = translations.map.remove_from_filter;
      actionClass = 'remove-filter';
    } else if (feature.type === 'Overlay Shape') {
      actionText = translations.map.add_to_filter;
      actionClass = 'add-filter';
    } else if (feature.type.includes('Drawn Shape')) {
      actionText = 'Edit shape';
      actionClass = 'edit-shape';
    } else {
      actionText = 'Action';
      actionClass = 'default-action';
    }

    const actionLink = $('<a href="#" class="action-link ' + actionClass + '"></a>').text(actionText);

    // Create a container for the circle and name to keep them together
    const leftContainer = $('<div class="left-container"></div>');

    // Build the structure correctly from the start
    leftContainer.append(colorCircle, nameSpan);
    item.append(leftContainer, actionLink);

    // Add click handler for the entire menu item
    item.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.handleContextMenuAction(feature, actionText, originalMapEvent);
      this.closeCurrentMenu();
    });

    return item;
  }

  cleanupRightLeftContent() {
    this.closeCurrentMenu();
  }

  /* ------------------------------------------------------------ */
  /* ------------------- Context menu methods ------------------- */
  /* ------------------------------------------------------------ */

  handleContextMenuAction(feature, action, originalMapEvent) {
    if (feature.type.includes('Drawn Shape') && action === 'Edit shape') {
      this._handleDrawnShapeEdit(feature, originalMapEvent);
    } else if (feature.type.includes('Overlay Shape')) {
      if (action === translations.map.add_to_filter) {
        this._handleOverlayShapeAddition(feature);
      } else if (action === translations.map.remove_from_filter) {
        this._handleOverlayShapeRemoval(feature);
      }
    }
  }

  _handleDrawnShapeEdit(feature, originalMapEvent) {
    // Add a small delay to let the map click handler finish
    setTimeout(() => {
      const forwardedEvent = {
        domEvent: {
          pageX: originalMapEvent.domEvent.pageX,
          pageY: originalMapEvent.domEvent.pageY,
          clientX: originalMapEvent.domEvent.clientX,
          clientY: originalMapEvent.domEvent.clientY,
          target: originalMapEvent.domEvent.target,
          currentTarget: originalMapEvent.domEvent.currentTarget,
          type: 'click'
        },
        latLng: originalMapEvent.latLng,
        stop: originalMapEvent.stop,
        stopImmediatePropagation: originalMapEvent.stopImmediatePropagation
      };
      google.maps.event.trigger(feature.shape, 'click', forwardedEvent);
    }, 10); // 10ms delay
  }

  _handleOverlayShapeAddition(feature) {
    let overlayShape = GlobalOverlayManager.getLoadedMyMapOverlayShape(feature.overlayShapeId.substring(0,26));
    if (overlayShape !== null) {
      if ($('#locationSearch').length > 0) {
        // We have a filter panel.  Lets use that to add the overlay shape to the filter.
        let searchLocationValues = $('#locationSearch').val() || [];

        searchLocationValues.push('MapOverlayShape_' + overlayShape.Id)

        // This is mimicking what happens when you select an item in the location box
        let locationOption = `<option value="MapOverlayShape_${overlayShape.Id}">${overlayShape.Name} - ${overlayShape.Name} (Map Overlay Shape)</option>`
        $('#locationSearch').append($(locationOption))

        // Always create/update the annotation here so map-driven additions work even if the
        // grouped select element isn't present in the DOM (e.g., in tests or partial renders).
        // If grouped-select2/search-filters also creates it, the helper is idempotent.
        createOverlayShapeAnnotation(
          overlayShape.Id,
          overlayShape.OverlayId,
          overlayShape.OverlayName || overlayShape.OverlayId,
          overlayShape.Name
        );

        // Add to new overlays select (grouped-select2) via event
        // If a new group is being created and an intersection already exists, use the intersection operator mode.
        let newGroupOperator = ($('.has-shapes-operator[data-active="and"]').length > 0) ? 'and' : 'or';

        // The event handler will manage annotations, so we don't add them here
        const groupedSelectElement = document.getElementById('groupedOverlaysSelect');
        if (groupedSelectElement) {
          const shapeData = {
            id: `'${overlayShape.Id}'`,
            text: overlayShape.Name,
            color: "#" + overlayShape.Color,
            overlayId: overlayShape.OverlayId,
            overlayName: overlayShape.OverlayName || overlayShape.OverlayId,
            notFromLocations: true,
            newGroupOperator: newGroupOperator
          };

          groupedSelectElement.dispatchEvent(new CustomEvent('addOverlayShape', {
            detail: shapeData,
            bubbles: true
          }));

          SearchItemContainer.updateGroupedSelectSummary(document.getElementById('visualGroupedOverlaysSelect'));

          let $container = $(groupedSelectElement.closest('.c-card'));
          $container.removeClass('no-overlays');
          $container.find('.c-collapsible__content.filter_item_container').find('*').removeClass('dont_serialize');
          SearchItemContainer.expandContainer($container);
          SearchItemContainer.checkContainer($container, true);
        }
        this.triggerFilterPanelUpdates(searchLocationValues, false)
      } else {
        // Add the overlay shape to the filter when filter panel is not loaded
        let filter = getState('filter');

        // Create the expression object
        let expression = {
          type: 'character',
          block_group: 0,
          condition: "'" + overlayShape.Id + "'",
          conjunction: "And",
          conjunction_level: 0,
          custom_field: false,
          field: 'MapOverlayShape',
          level: 0,
          operator: 'Eq',
          value: [overlayShape.Id]
        };

        // Add the shape using the filter's method (which handles Shape Group matching internally)
        filter.addOverlayShapeToFilter(expression, overlayShape.OverlayId);

        // Create annotation using helper and get the returned annotation object
        let annotation = createOverlayShapeAnnotation(
          overlayShape.Id,
          overlayShape.OverlayId,
          overlayShape.OverlayName || overlayShape.OverlayId,
          overlayShape.Name
        );

        let newBounds = this._calculateCombinedBounds(feature.shape);
        this._handleExistingOverlayShapes(filter, newBounds);
        this._overlayAddedToFilterFromMap(filter, newBounds, annotation);
        this.map.updateFilterPanelSrc(filter);
      }
    } else {
      toast.error('Could not match map shape with an overlay shape');
    }
  }

  _calculateCombinedBounds(shape) {
    let newBounds = this.map.getDrawnShapesBounds();
    let moreBounds = GlobalOverlayManager.getTotalMapOverlayShapeBounds(shape);
    if (newBounds === null) {
      // They cant both be null or we wouldnt be here
      newBounds = moreBounds
    } else if (moreBounds !== null) {
      // If both are NOT null, combine them.
      newBounds.union(moreBounds)
    }
    return newBounds;
  }

  _handleExistingOverlayShapes(filter, newBounds) {
    const $visualSelect = $('#visualGroupedOverlaysSelect');
    if ($visualSelect.length === 0) { return; }

    // If the overlays container is unchecked, the grouped control is marked dont_serialize,
    // but we still need to keep existing shapes in the filter/bounds when adding from the map.
    if (!$visualSelect.hasClass('dont_serialize')) { return; }

    if ($visualSelect.find('option').length > 0) {
      // Ensure annotations match what is currently in the grouped select
      this.refreshAnnotations('Overlay');
    }

    $visualSelect.find('option').each(function() {
      const value = $(this).val();
      const existingOS = GlobalOverlayManager.getLoadedMyMapOverlayShape(value.replace(/'/g, ''));
      if (existingOS !== null) {
        filter.addMapOverlayShapeToFilter(existingOS);
        // Convert the shape data to a Google Maps Polygon for bounds calculation
        const tempGoogleShape = GlobalOverlayManager.convertShapeToGooglePolygon(existingOS);
        const thisShapesBounds = GlobalOverlayManager.getTotalMapOverlayShapeBounds(tempGoogleShape);
        if (thisShapesBounds) {
          newBounds.union(thisShapesBounds);
        }
      }
    });
  }

  _handleOverlayShapeRemoval(feature) {
    let overlayShape = GlobalOverlayManager.getLoadedMyMapOverlayShape(feature.overlayShapeId.substring(0,26));
    if (overlayShape !== null) {
      if ($('#locationSearch').length > 0) {
        // We have a filter panel. Let's use that to remove the overlay shape from the filter.
        const valueToRemove = 'MapOverlayShape_' + overlayShape.Id;

        // Remove from new overlays select (grouped-select2) via event
        const groupedSelectElement = document.getElementById('groupedOverlaysSelect');
        if (groupedSelectElement) {
          groupedSelectElement.dispatchEvent(
            new CustomEvent('removeOverlayShape', {
              detail: { childId: `'${overlayShape.Id}'` },
              bubbles: false
            })
          );

          SearchItemContainer.updateGroupedSelectSummary(document.getElementById('visualGroupedOverlaysSelect'));
        }

        // Remove from locationSearch using the proper method (which handles select2 state correctly)
        const locationSearch = searchFormFlex.getLocationSearch();
        if (locationSearch) {
          locationSearch.removeValue(valueToRemove);
        }
      } else {
        // Remove the overlay shape from the filter the old fashioned way:
        // By removing it directly from the filter.
        let filter = getState('filter');

        // Get the annotation before removing it (we'll need it for cleanup)
        let annotations = JSON.parse(JSON.stringify(getState('annotations')));
        let annotation = annotations.filter(a => a.Match.Substring == "'" + feature.overlayShapeId + "'");
        if (annotation.length > 0) {
          annotation = annotation[0]
        }

        // Remove the shape from the filter
        filter.removeShapeByCondition("'" + feature.overlayShapeId + "'");

        // Remove the shape from the global overlay manager
        GlobalOverlayManager.removeFilterOverlayShapeFromMap(feature.overlayShapeId);

        let newBounds = this._calculateCombinedBounds(feature.shape);
        this._overlayRemovedFromFilterFromMap(filter, newBounds, annotation);
        this.map.updateFilterPanelSrc(filter);
      }
    } else {
      toast.error('Could not match map shape with an overlay shape');
    }
  }

  // Apparently the map cannot tell us what we clicked on if they are shapes that we
  // have drawn.  (My map overlays are still part of that.)  So we have to detect
  // what we clicked on by checking the shapes that are on the map.
  detectClickedFeatures(event) {
    const features = [];
    const clickPoint = event.latLng;

    // Use Google Maps' built-in feature detection
    try {
      // Always check shapes (markers are handled separately in handleMapClick)
      this._detectOverlayShapes(clickPoint, features);
      this._detectDrawnShapes(clickPoint, features);

      // Sort features by z-index to determine which is on top
      features.sort((a, b) => b.zIndex - a.zIndex);
    } catch (error) {
      toast.error('Unable to process map click:', error);
    }

    return features;
  }

  _detectOverlayShapes(clickPoint, features) {
    // Check overlay shapes from GlobalOverlayManager
    const allOverlays = GlobalOverlayManager.data.overlaysOnTheMap;
    const filteredOverlayShapes = GlobalOverlayManager.data.filteredOverlayShapesOnTheMap;

    // Create a map to track which shapes we've already processed
    const processedShapes = new Map();

    // First, process individual filtered overlay shapes (highest priority)
    this._processFilteredOverlayShapes(filteredOverlayShapes, clickPoint, features, processedShapes);

    // Then process regular overlays, but skip if already processed as filtered
    this._processRegularOverlayShapes(allOverlays, clickPoint, features, processedShapes);
  }

  _processFilteredOverlayShapes(filteredOverlayShapes, clickPoint, features, processedShapes) {
    const keys = Object.keys(filteredOverlayShapes);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const shapes = filteredOverlayShapes[key];
      for (let j = 0; j < shapes.length; j++) {
        const googleShape = shapes[j];
        try {
          // Skip invisible shapes to prevent menu interactions
          if (googleShape.getVisible() === false) continue;

          if (google.maps.geometry.poly.containsLocation(clickPoint, googleShape)) {
            processedShapes.set(key, true);
            features.push({
              type: 'Filtered Overlay Shape',
              shape: googleShape,
              overlayId: key,
              overlayShapeId: googleShape.get('overlayShapeId'),
              zIndex: googleShape.get('zIndex') || 0
            });
          }
        } catch (error) {
          toast.error('Error processing filtered overlay shape:', error);
        }
      }
    }
  }

  _processRegularOverlayShapes(allOverlays, clickPoint, features, processedShapes) {
    const parentOverlayIds = Object.keys(allOverlays);
    for (let i = 0; i < parentOverlayIds.length; i++) {
      const parentOverlayId = parentOverlayIds[i];
      const shapes = allOverlays[parentOverlayId];
      for (let j = 0; j < shapes.length; j++) {
        const googleShape = shapes[j];
        try {
          // Skip invisible shapes to prevent menu interactions
          if (googleShape.getVisible() === false) continue;

          if (google.maps.geometry.poly.containsLocation(clickPoint, googleShape)) {
            if (!processedShapes.has(googleShape.get('overlayShapeId'))) {
              features.push({
                type: 'Overlay Shape',
                shape: googleShape,
                overlayId: parentOverlayId,
                overlayShapeId: googleShape.get('overlayShapeId'),
                zIndex: googleShape.get('zIndex') || 0
              });
            }
          }
        } catch (error) {
          toast.error('Error processing unfiltered overlay shape:', error);
        }
      }
    }
  }

  _detectDrawnShapes(clickPoint, features) {
    // Check drawn shapes from the drawing manager
    if (this.map.drawingManager && this.map.drawingManager.drawings) {
      const drawings = this.map.drawingManager.drawings;
      for (let index = 0; index < drawings.length; index++) {
        const drawing = drawings[index];
        try {
          this._checkDrawnShapeType(drawing, clickPoint, features, index);
        } catch (error) {
          toast.error('Error processing drawn shapes', error);
        }
      }
    }
  }

  _checkDrawnShapeType(drawing, clickPoint, features, index) {
    if (drawing.getVisible() === false) return;
    // Check if it's a circle
    if (drawing.getCenter && drawing.getRadius) {
      const center = drawing.getCenter();
      const radius = drawing.getRadius();
      const distance = google.maps.geometry.spherical.computeDistanceBetween(clickPoint, center);
      if (distance <= radius) {
        features.push({
          type: 'Drawn Shape (Circle)',
          shape: drawing,
          zIndex: drawing.get('zIndex') || 0
        });
      }
    } else if (drawing.getPath && drawing.getPath().getLength && drawing.getPath().getLength() > 0) {
      if (google.maps.geometry.poly.containsLocation(clickPoint, drawing)) {
        features.push({
          type: 'Drawn Shape (Polygon)',
          shape: drawing,
          zIndex: drawing.get('zIndex') || 0
        });
      }
    } else if (drawing.getBounds) {
      if (drawing.getBounds().contains(clickPoint)) {
        features.push({
          type: 'Drawn Shape (Rectangle)',
          shape: drawing,
          zIndex: drawing.get('zIndex') || 0
        });
      }
    }
  }

  _detectMarkers(event, features) {
    // Check if any listing markers are at the click point
    if (typeof markerManager !== 'undefined' && markerManager.getListingMarkers) {
      const clickX = event.domEvent.clientX;
      const clickY = event.domEvent.clientY;
      const listingMarkers = markerManager.getListingMarkers();

      // Early exit optimization: stop checking once we find a marker
      for (let i = 0; i < listingMarkers.length; i++) {
        const marker = listingMarkers[i];
        try {
          // Use the marker's containsPoint method for accurate detection
          if (marker.label && marker.label.labelDiv_) {
            if (marker.containsPoint(clickX, clickY)) {
              features.push({
                type: 'Listing Marker',
                marker: marker,
                listingId: marker.listingId,
                zIndex: 1000 // Markers should have higher priority than shapes
              });
              // Early exit - we found a marker, no need to check others
              break;
            }
          }
        } catch (error) {
          // Ignore errors for individual markers
        }
      }
    }
  }

  /* ------------------------------------------------------------ */
  /* -------------- Methods for adding overlays ----------------- */
  /* ------------------------------------------------------------ */
  _overlayAddedToFilterFromMap(filter, newBounds, annotation) {
    // A lot of the prep work has been done.  This is actually puts stuff in place.
    this.map.freeze();

    setState('filter', filter);

    // Make shapes visible when overlay shapes are added to filter (same as when drawing starts)
    this.toggleAllShapesVisibility(true);

    this.map.moveMapToBoundary(newBounds).then((bounds) => {
      // Since the map is frozen, the bounds need to be updated manually.
      setState('mapBounds', bounds);

      this.map.unfreeze();

      this.map.updateMap().done(() => {
        setState('listingCountTotal', this.map.mappedListingCount());
      });
    });

    this._addItemToOverlaysFilterContainer(annotation)
    this._addItemToLocationSearchItem(annotation)
  }

  _addItemToLocationSearchItem(annotation) {
    let searchLocationValues = $('#locationSearch').val() || [];
    let value = 'MapOverlayShape_' + annotation.Attributes.Shape;
    let label = annotation.Attributes.ShapeName || value;

    // Add the option if it doesn't exist
    if ($('#locationSearch option[value="' + value + '"]').length === 0) {
      let newOption = new Option(label, value, true, true);
      $('#locationSearch').append(newOption);
    }

    // Set the value, but do NOT trigger 'change'
    if (!searchLocationValues.includes(value)) {
      searchLocationValues.push(value);
      $('#locationSearch').val(searchLocationValues);
    }
  }

  _addItemToOverlaysFilterContainer(annotation) {
    let newOverlayShapeValue = `'${annotation.Attributes.Shape}'`;

    // If a new group is being created and an intersection already exists, use the intersection operator mode.
    let newGroupOperator = ($('.has-shapes-operator[data-active="and"]').length > 0) ? 'and' : 'or';

    // Dispatch event that the generic controller will listen for
    const groupedSelectElement = document.getElementById('groupedOverlaysSelect');
    if (groupedSelectElement) {
      const shapeData = {
        id: newOverlayShapeValue,
        text: annotation.Attributes.ShapeName,
        color: "#" + annotation.Attributes.Color,
        overlayId: annotation.Attributes.Overlay,
        overlayName: annotation.Attributes.OverlayName || annotation.Attributes.Overlay,
        notFromLocations: true,
        newGroupOperator: newGroupOperator
      };

      // Dispatch custom event that the generic controller will listen for
      groupedSelectElement.dispatchEvent(new CustomEvent('addOverlayShape', {
        detail: shapeData,
        bubbles: true
      }));
      SearchItemContainer.updateGroupedSelectSummary(document.getElementById('visualGroupedOverlaysSelect'));

      // Expand and check the container
      let collapsibleElement = $(groupedSelectElement.closest('.c-card'));
      collapsibleElement.removeClass('no-overlays');
      collapsibleElement.find('.c-collapsible__content.filter_item_container').find('*').removeClass('dont_serialize');
      SearchItemContainer.expandContainer(collapsibleElement);
      SearchItemContainer.checkContainer(collapsibleElement, true);
    }
  }


  /* ------------------------------------------------------------ */
  /* ----- Methods for removing overlays via map shapes menu ---- */
  /* ------------------------------------------------------------ */
  _overlayRemovedFromFilterFromMap(filter, newBounds, annotation) {
    // This method follows the same pattern as _overlayAddedToFilterFromMap but removes instead of adds
    this.map.freeze();

    if (annotation) {
      // Remove overlay shape annotation using helper
      removeOverlayShapeAnnotation(annotation.Attributes.Shape);
    }

    setState('filter', filter);

    // Make shapes visible when overlay shapes are removed from filter (same as when adding)
    this.toggleAllShapesVisibility(true);

    this.map.moveMapToBoundary(newBounds).then((bounds) => {
      // Since the map is frozen, the bounds need to be updated manually.
      setState('mapBounds', bounds);

      this.map.unfreeze();

      this.map.updateMap().done(() => {
        setState('listingCountTotal', this.map.mappedListingCount());
      });
    });

    this._removeItemFromOverlaysFilterContainer(annotation)
    this._removeItemFromLocationSearchItem(annotation)
  }

  _removeItemFromOverlaysFilterContainer(annotation) {
    let valueToRemove = `'${annotation.Attributes.Shape}'`;

    // Remove from new overlays select (grouped-select2)
    // Use the silent removal path to avoid circular event flows (same as locationSearch removal)
    const groupedSelectElement = document.getElementById('groupedOverlaysSelect');

    if (groupedSelectElement) {
      // Dispatch namespace-aware remove event (consistent with addOverlayShape)
      groupedSelectElement.dispatchEvent(
        new CustomEvent('removeOverlayShape', {
          detail: { childId: valueToRemove },
          bubbles: false
        })
      );
      SearchItemContainer.updateGroupedSelectSummary(document.getElementById('visualGroupedOverlaysSelect'));
    }
  }

  _removeItemFromLocationSearchItem(annotation) {
    // Use the locationSearch object's removeValue method (same as location search removal path)
    const locationSearch = searchFormFlex.getLocationSearch();
    if (locationSearch) {
      const shapeId = annotation.Attributes.Shape;
      const locationSearchValue = `MapOverlayShape_${shapeId}`;
      locationSearch.removeValue(locationSearchValue);
    }
  }

  myLocation(evt) {
    evt?.preventDefault?.();
    this.closeCurrentMenu();

    if (typeof Cookies.get(SUPPRESS_GPS_SEARCH_CONFIRM_COOKIE) !== 'undefined') {
      this.runMyLocationConfirmed();
      return;
    }

    const t = translations.map.my_location_confirm;
    window.dispatchEvent(
      new CustomEvent("display-local-modal", {
        detail: {
          modalCssClasses: "modal-dialog modal-sm c-modal cart-modal",
          modalHeader: `<div class="t-title--large">${t.title}</div>`,
          modalContent: `<p>${t.body}</p>
              <br>
              <div class="c-card-enable">
                <input type="checkbox" id="dontShowGpsSearchConfirmAgain" />
                <label for="dontShowGpsSearchConfirmAgain">${t.dont_show_again}</label>
              </div>`,
          modalFooterContent: `<button class="btn btn-secondary" data-dismiss="modal" type="button">${t.cancel}</button><button class="btn btn-primary" data-action="click->map--my-location-confirm#confirm" type="button">${t.confirm}</button>`,
          modalDataController: "map--my-location-confirm",
        },
      })
    );
  }

  runMyLocationConfirmed() {
    if (!this.map || typeof this.map.whenMyLocationPannedThen !== "function") {
      return;
    }

    // GPS first and commit mapBounds (viewport near device) before prefilter teardown + reloadData,
    // so cluster/filter refresh uses bounds around GPS.
    $.when(this.map.whenMyLocationPannedThen()).always(() => {
      $.when(this.disablePrefilteredFields());
    });
  }

  /**
   * @param {string} label - StandardField / custom Label, or map section title (e.g. "Drawn Shapes", "Overlays")
   * @returns {JQuery} .c-card rows whose primary enable label matches (trimmed exact text).
   * 
   * Check by label because it's consistent and easier to find in the DOM.
   * The SparkQl can change after DB syncs
   * Ex: "General Property Description"."Total Bedrooms" later becomes BedsTotal
   */
  prefilterFieldCardsByLabel(label) {
    const normalized = String(label).trim();
    if (!normalized) {
      return $();
    }
    return $('#filterPanel').find('.c-card .c-card-enable label').filter(function () {
      return $(this).text().trim() === normalized;
    }).closest('.c-card');
  }

  /**
   * @returns {JQuery.Promise} Resolves when any prefilter batch reload finishes, or immediately if none.
   */
  disablePrefilteredFields() {
    const done = $.Deferred().resolve();

    const turboFrame = this.element.closest('turbo-frame');
    if (!turboFrame) {
      return done.promise();
    }

    const frameSrc = turboFrame.getAttribute("src");
    if (!frameSrc) {
      return done.promise();
    }

    const prefilteredFields = mapSupport.prefilteredFields;
    if (prefilteredFields.length === 0) {
      return done.promise();
    }

    const seen = new Set();
    const checkboxes = [];
    prefilteredFields.forEach((label) => {
      this.prefilterFieldCardsByLabel(label).each((_i, card) => {
        const cb = $(card).find('.c-card-enable input.filter_item_container[type="checkbox"]')[0];
        if (cb && cb.checked && !seen.has(cb)) {
          seen.add(cb);
          checkboxes.push(cb);
        }
      });
    });

    if (checkboxes.length === 0) {
      return done.promise();
    }

    this._preserveViewportAfterPrefilterReload = true;
    this.map.freeze();

    const req = searchFormFlex.batchFilterCheckboxUnchecked(checkboxes) || done.promise();
    return $.when(req).always(() => {
      this._preserveViewportAfterPrefilterReload = false;
      this.map.unfreeze();
      // refreshMapShapes is a no-op while frozen; sync drawn shapes / radius UI to filter now.
      this.map.refreshMapShapes();
      this.map.updateMap();
    });
  }

  refreshAnnotations(type) {
    // We are probably adding things to the annotations that were no there
    // because the parent container is unchecked.  If we are here, we want
    // the annotations to include all existing Select2 data matching the specified type.
    // (drawnshapes or overlay shapes)
    // First, start from scratch
    searchFormFlex.removeAnnotations(type);
    // Then read the select2 data and recreate the annotations
    searchFormFlex.recreateAnnotations(type);
  }

}
